import { ProductKey } from "@/components/signup/utils/products";
import { useUserContext } from "@/components/user-context/user-context-provider";

import { CFindEmbeddedSignupForm } from "./embedded-variants/cfind-embedded-signup";
import { ConfluenceFeaturesPageEmbeddedSignupForm } from "./embedded-variants/confluence-features-page-embedded";
import { DefaultEmbeddedSignupForm } from "./embedded-variants/default-form";
import { LoggedInForm } from "./embedded-variants/logged-in-form";

import type { ConfluenceAnchorVariant } from "./paid-hero";

export const variants = {
    "paid-lp-conf-features": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-conf-features" />
    ),
    "paid-lp-confl-projectmgmt": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-projectmgmt" />
    ),
    "paid-lp-confl-documentation": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-documentation" />
    ),
    "paid-lp-confl-template": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="paid-lp-confl-template" />
    ),
    "anchor-lp-conf-automation": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-automation" />
    ),
    "anchor-lp-conf-collaboration": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-collaboration" />
    ),
    "anchor-lp-conf-teamwork": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-teamwork" />
    ),
    "anchor-lp-conf-work-management": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-work-management" />
    ),
    "anchor-lp-conf-competitors": (
        <ConfluenceFeaturesPageEmbeddedSignupForm variant="anchor-lp-conf-competitors" />
    ),
    "default": <DefaultEmbeddedSignupForm />,
    "confluence-default": <CFindEmbeddedSignupForm />
};

export const EmbeddedSignupForm = ({ pageId }: { pageId: string }) => {
    const { product, user } = useUserContext();

    if (user.isUserLoggedIn) {
        return <LoggedInForm />;
    }

    let variantName: ConfluenceAnchorVariant = "default";

    if (product?.key === ProductKey.CONFLUENCE) {
        variantName = "confluence-default";
    }

    if (pageId in variants) {
        variantName = pageId as ConfluenceAnchorVariant;
    }

    return variants[variantName];
};
